// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2AwoS","right":"styles_right__3H0MI"};